<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates34">
<p class="centerImage"><img alt="images" id="plate35" src="images/plate35.jpg"/></p>
<p class="caption">Our CO, Bill Gibbs, taking it easy. Obviously the newspaper headlines – Japs’ Raid on W.A. Coast, Planes Driven off – have worn him out.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates35.vue?7f1777a5